/**
 * Parses the card object for data
 * @param {object} card object
 * @returns {string} object with parsed values
 */
const getCardInfo = card => {
  return {
    billingCountryCode: card?.billingAddress?.countryCode ?? null,
    cardBrand: card?.paymentType?.cardBrand ?? null,
    cardType: card?.paymentType?.cardType ?? null,
    fullBillingAddress: card?.billingAddress ?? {},
    // Expected values for billingAccepted - true or false. defaulted to true since this prop is an optional.
    isBillingAddressAccepted: card?.billingAddress?.billingAccepted ?? true,
    isExpired: card?.expired ?? false, // Expected values - true or false
    // START GENAI@GHCOPILOT
    isIssuerManaged: card?.isIssuerManaged ?? false, // Expected values - true or false
    // END GENAI@GHCOPILOT
    verificationStatus: card?.verificationStatus ?? null // Expected values - NOT_VERIFIED or VERIFIED
  };
};
export default getCardInfo;
